<div [ngClass]="loadPosition()" [class.active]="show">
    <div class="container-1">
        <i class="fa" [ngClass]="{
      'fa-times-circle': toastDetails?.type === 'error',
      'fa-check-circle': toastDetails?.type === 'success',
      'fa-exclamation-circle': toastDetails?.type === 'warning',
      'fa-info-circle': toastDetails?.type === 'info'
    }"></i>
    </div>
    <div class="container-2">
        <p>{{ toastDetails?.detail }}</p>
        <p>{{ toastDetails?.summary }}</p>
    </div>
    <button *ngIf="show" id="close" (click)="closeToast()">&times;</button>
</div>